import { Button, ButtonProps } from '@mui/material';
import TooltipContent from './TooltipContent';
interface IconButtonProps extends ButtonProps {
  tooltip?: string;
  variant?: 'text' | 'outlined' | 'contained';
  minWidth?: string;
}

export const IconButtonMui: React.FC<IconButtonProps> = ({
  children,
  disabled,
  tooltip,
  variant,
  minWidth,
  ...rest
}) => {
  return (
    <TooltipContent showTooltip={disabled === true} title={tooltip ?? ''}>
      <Button
        {...rest}
        disabled={disabled}
        variant={variant ?? 'contained'}
        sx={{
          minWidth: minWidth ?? 'inherit',
          '&:disabled': {
            opacity: 0.5,
            bgcolor: ({ palette }) => palette.primary.main,
            color: ({ palette }) => palette.primary.contrastText
          }
        }}
      >
        {children}
      </Button>
    </TooltipContent>
  );
};
